// Angular modules
import { Component }          from '@angular/core';

// Ionic modules
import { GoogleAnalytics }    from '@ionic-native/google-analytics';
import { NavController }      from 'ionic-angular';
import { MenuController }     from 'ionic-angular';
import { LoadingController }  from 'ionic-angular';
import { ToastController }    from 'ionic-angular';

// External modules
import { Mixture }            from '../../shared/models/mixture';
import { ApplicationService } from '../../shared/providers/application-service';
import { MixturesResultPage } from '../mixtures-result/mixtures-result';
import { TranslateService }   from '@ngx-translate/core';

// Helpers
import { StorageHelper }      from '../../shared/helpers/storage.helper';
import { SynchronizePage } from '../synchronize/synchronize';

@Component({
  selector: 'page-find-competitor',
  templateUrl: 'find-competitor.html',
  providers:[ApplicationService]
})

export class FindCompetitorPage
{
  mixtures        : Mixture[] = [];
  competitors     : string[]  = [];
  competitorMap   : any;
  selectedMixture : Mixture   = null;
  isDetail        : boolean   = false;
  overlayIndex    : number    = 0;
  user            : any       = null;
  waitingLabel    : string    = "Please wait...";
  overlayArray    : string [] = ['assets/menu_overlay_4.png',
                                 'assets/menu_overlay_5.png',
                                 'assets/menu_overlay_6.png',
                                 'assets/menu_overlay_7.png',
                                 'assets/menu_overlay_8.png',
                                 'assets/menu_overlay_9.png'];


  constructor(public navCtrl            : NavController,
              public loadingCtrl        : LoadingController,
              public toastCtrl          : ToastController,
              public applicationService : ApplicationService,
              public translate          : TranslateService,
              public menuCtrl           : MenuController,
              private analytics  : GoogleAnalytics)
  {
    var context = this;

  if(StorageHelper.getMixtures() === null)
  {
    this.presentToast('You need to synchronize your data before accessing this feature');
    this.navCtrl.push(SynchronizePage);
    return;
  }

    context.user = StorageHelper.getUser();
    context.initMixtures(function()
    {
      console.info("[Function] constructor -> mixtures are rested");
    });
  }

  ionViewDidLoad()
  {
    this.analytics.trackView("Find a competitor");

    this.initTranslations();
  }

  initTranslations()
  {
    var context = this;
    this.translate.get('PLEASE_WAIT').subscribe(
      value => {
        context.waitingLabel = value;
      })
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  presentLoading()
  {
    var context = this;
    let loader = this.loadingCtrl.create({
       content: context.waitingLabel
    });

     return loader;
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  initMixtures(callback)
  {
    let loader  = this.presentLoading();

    const mixtures = StorageHelper.getMixtures();
    if(mixtures != null)
    {
      this.mixtures = mixtures;
      this.loadMixtures(mixtures);
    }
    else
    {
      this.presentToast("Missing Mixtures, please synchronize before.");
    }

    loader.dismiss();
    callback();
  }

  loadMixtures(data)
  {
    var context = this;

    if(data == null)
      return;

    if(!this.competitorMap)
    {
      this.competitorMap = {};
      data.forEach(function(item)
      {
        context.mixtures.push(<Mixture> item);

        if(!context.competitorMap[item.Enterprise])
          context.competitorMap[item.Enterprise] = [];

        context.competitorMap[item.Enterprise].push(<Mixture> item);
      });
      this.competitors = Object.keys(this.competitorMap);
    }
    else
      this.mixtures = <Mixture[]> data;
  }

  backAction()
  {
    if(this.isDetail)
    {
      this.isDetail = false;
      this.initMixtures(function()
      {
        console.info("[Function] backAction -> mixtures are rested");
      });
      return;
    }

    this.navCtrl.pop({animate: false});
  }

  selectCompetitor(item)
  {
      this.selectedMixture = item;
      this.isDetail        = true;
      this.getmixtures(item);
  }

  selectMixture(item)
  {
    var context = this;
    this.initMixtures(function()
    {
      context.selectedMixture = item;
      var moleculeCompo    = '';
      var alEquiv          = '';

      var equivalent  = context.mixtures.filter((mixt) =>
      {
        if(mixt.N2 != context.selectedMixture.N2)
          return false;

        if(mixt.O2 != context.selectedMixture.O2)
          return false;

        if(mixt.CO2 != context.selectedMixture.CO2)
          return false;

        if(mixt.He != context.selectedMixture.He)
          return false;

        if(mixt.Ar != context.selectedMixture.Ar)
          return false;

        if(mixt.H != context.selectedMixture.H)
          return false;

        if(mixt.NO != context.selectedMixture.NO)
          return false;

        if(mixt.Enterprise == "AIR LIQUIDE")
        {
            alEquiv = mixt.Name;
            return false;
        }

        if(mixt.Name == context.selectedMixture.Name)
            return false;

        return true;
      })

      moleculeCompo = context.getComposition();
      moleculeCompo = moleculeCompo.substr(0, moleculeCompo.length-2);

      context.getmixtures(item.Enterprise);

      context.navCtrl.push(MixturesResultPage,
      {
        item,
        equivalent,
        moleculeCompo,
        alEquiv
      }, {animate: true});
      });
  }

  getComposition()
  {
    var moleculeCompo = '';
    var context       = this;

    if(context.selectedMixture.N2 != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.N2 + '% N2, ';

    if(context.selectedMixture.O2 != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.O2 + '% O2, ';

    if(context.selectedMixture.CO2 != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.CO2 + '% CO2, ';

    if(context.selectedMixture.He != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.He + '% He, ';

    if(context.selectedMixture.Ar != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.Ar + '% Ar, ';

    if(context.selectedMixture.H != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.H + '% H, ';

    if(context.selectedMixture.NO != null)
      moleculeCompo = moleculeCompo + context.selectedMixture.NO + '% NO ,';

    return moleculeCompo;
  }

  getOverlay()
  {
    if(this.overlayIndex == 5)
      this.overlayIndex = 0;

    this.overlayIndex++;

    return this.overlayArray[this.overlayIndex];
  }

  getmixtures(enterpise)
  {
    let val     = enterpise;
    var context = this;
     this.initMixtures(function()
     {
        context.mixtures = context.mixtures.filter((item) => {
          return (context.normalizeKey(item.Enterprise) == context.normalizeKey(val));
        })
     });
   }

   normalizeKey(key)
   {
     var normKey = key.replace(/[\t\v\f\r \u00a0\u2000-\u200b\u2028-\u2029\u3000]+/g,'').trim();
     normKey     = normKey.replace(/<\/?[^>]+(>|$)/g, "");

     return normKey.toLowerCase();
   }
}



// WEBPACK FOOTER //
// ./src/app/pages/find-competitor/find-competitor.ts